import Head from 'components/profileNavigation/Head';
import DeleteUser from 'components/UserInformation/DeleteUser';
import UserInformationDisplay from 'components/UserInformation/UserInformationDisplay';
import { FC, useContext } from 'react';
import { MentorEditContext } from '.';

const GeneralInformation: FC = () => {
  const { mentor } = useContext(MentorEditContext);
  return (
    <>
      <section>
        <Head
          title="Informations générales"
          subtitle="Liste toutes les informations sur l'utilisateur"
        />
        <div>
          <UserInformationDisplay
            user={mentor}
            variant="mentor"
            reader="admin"
          />
        </div>
        <DeleteUser id={mentor?.id || -1} redirect="/admin/mentoring/mentors" />
      </section>
    </>
  );
};

export default GeneralInformation;
